module.exports = __webpack_public_path__ + "static/img/qdt@3x.2c6bd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qdt@3x.png
// module id = 8bI7
// module chunks = 1